enum SettingsPageEntry {
  ManagingBuilding,
  Organization,
  ManagingLicenses,
  Members,
  PreventiveMaintenance,
  FloorPlan,
  EnergyMonitoring,
  DataExport,
  ManagingCustomScenarios,
  WiFiCredentials,
  SetupCommissioning,
}

namespace SettingsPageEntry {
  export function getTextLabelKey(entry: SettingsPageEntry): string {
    switch (entry) {
      case SettingsPageEntry.ManagingBuilding:
        return 'Settings_ManagingBuilding';
      case SettingsPageEntry.Organization:
        return 'Settings_Organization';
      case SettingsPageEntry.ManagingLicenses:
        return 'Settings_ManagingLicenses';
      case SettingsPageEntry.Members:
        return 'Settings_Members';
      case SettingsPageEntry.PreventiveMaintenance:
        return 'Settings_Predictive_Maintenance';
      case SettingsPageEntry.FloorPlan:
        return 'Settings_FloorPlan';
      case SettingsPageEntry.EnergyMonitoring:
        return 'Settings_EnergyMonitoring';
      case SettingsPageEntry.DataExport:
        return 'Settings_DataExport';
      case SettingsPageEntry.ManagingCustomScenarios:
        return 'Settings_ManagingCustomScenarios';
      case SettingsPageEntry.WiFiCredentials:
        return 'Settings_WiFiCredentials';
      case SettingsPageEntry.SetupCommissioning:
        return 'Settings_SetupCommissioningSessions';
    }
  }

  export function allEntries(): Array<{
    value: SettingsPageEntry;
    onlyAdminAllowed: boolean;
    onlyBetaUserAllowed: boolean;
    textLabelKey: string;
    routeName: string;
  }> {
    return [
      { value: SettingsPageEntry.Organization, onlyAdminAllowed: false, onlyBetaUserAllowed: false, textLabelKey: getTextLabelKey(SettingsPageEntry.Organization), routeName: 'Organization' },
      { value: SettingsPageEntry.ManagingBuilding, onlyAdminAllowed: false, onlyBetaUserAllowed: false, textLabelKey: getTextLabelKey(SettingsPageEntry.ManagingBuilding), routeName: 'BuildingStructure' },
      { value: SettingsPageEntry.SetupCommissioning, onlyAdminAllowed: true, onlyBetaUserAllowed: false, textLabelKey: getTextLabelKey(SettingsPageEntry.SetupCommissioning), routeName: 'SetupCommissioning' },
      { value: SettingsPageEntry.WiFiCredentials, onlyAdminAllowed: true, onlyBetaUserAllowed: false, textLabelKey: getTextLabelKey(SettingsPageEntry.WiFiCredentials), routeName: 'WiFiCredentials' },
      { value: SettingsPageEntry.FloorPlan, onlyAdminAllowed: false, onlyBetaUserAllowed: false, textLabelKey: getTextLabelKey(SettingsPageEntry.FloorPlan), routeName: 'FloorPlan' },
      { value: SettingsPageEntry.ManagingLicenses, onlyAdminAllowed: false, onlyBetaUserAllowed: false, textLabelKey: getTextLabelKey(SettingsPageEntry.ManagingLicenses), routeName: 'ManagingLicenses' },
      { value: SettingsPageEntry.Members, onlyAdminAllowed: true, onlyBetaUserAllowed: false, textLabelKey: getTextLabelKey(SettingsPageEntry.Members), routeName: 'Members' },
      { value: SettingsPageEntry.EnergyMonitoring, onlyAdminAllowed: false, onlyBetaUserAllowed: false, textLabelKey: getTextLabelKey(SettingsPageEntry.EnergyMonitoring), routeName: 'EnergyMonitoring' },
      { value: SettingsPageEntry.PreventiveMaintenance, onlyAdminAllowed: false, onlyBetaUserAllowed: false, textLabelKey: getTextLabelKey(SettingsPageEntry.PreventiveMaintenance), routeName: 'PreventiveMaintenance' },
      { value: SettingsPageEntry.DataExport, onlyAdminAllowed: true, onlyBetaUserAllowed: false, textLabelKey: getTextLabelKey(SettingsPageEntry.DataExport), routeName: 'DataExport' },
      { value: SettingsPageEntry.ManagingCustomScenarios, onlyAdminAllowed: true, onlyBetaUserAllowed: true, textLabelKey: getTextLabelKey(SettingsPageEntry.ManagingCustomScenarios), routeName: 'ManagingCustomScenarios' },
    ];
  }
}

export default SettingsPageEntry;
